import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=2b6b985e&scoped=true&"
import script from "./paySuccess.vue?vue&type=script&lang=js&"
export * from "./paySuccess.vue?vue&type=script&lang=js&"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=2b6b985e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b985e",
  null
  
)

export default component.exports